import { Button, PivotGrid } from "devextreme-react";

import "./index.css";
import { useEffect, useState } from "react";
import axios from "axios";
import PivotGridDataSource from "devextreme/ui/pivot_grid/data_source";
import {
  Export,
  FieldChooser,
  FieldPanel,
  HeaderFilter,
  LoadPanel,
  Scrolling,
  Search,
  StateStoring,
} from "devextreme-react/pivot-grid";
import { Workbook } from "exceljs";
import { exportPivotGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver-es";

export default function IndividualReportGridLeft(props) {
  const { projectName, yearMonth } = props;

  const [dataSource, setDataSource] = useState(null);

  useEffect(async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/workR/rawData`
    );

    setDataSource(
      new PivotGridDataSource({
        fields: [
          {
            caption: "Project Name",
            dataField: "projName",
            area: "row",
            width: 600,
            selector(data) {
              return `[${data.contrNo}] ${data.projName}`;
            },
            // allowFiltering: true,
            // headerFilter: {
            //   showRelevantValues: false,
            //   search: {
            //     enabled: true,
            //     mode: "contains",
            //   },
            // },
            // sortBySummaryField: "Total",
          },
          {
            caption: "Task",
            dataField: "taskCat",
            area: "row",
            width: 600,
            // sortBySummaryField: "Total",
          },
          {
            caption: "Detailed Task",
            dataField: "detTask",
            area: "row",
            width: 600,
            // sortBySummaryField: "Total",
          },
          {
            caption: "Classification Work",
            dataField: "classifWork",
          },
          {
            caption: "Employee Name",
            dataField: "name",
            area: "filter",
            selector(data) {
              return `${data.name} (${data.employeeNo})`;
            },
          },
          {
            caption: "Division",
            dataField: "div",
            area: "filter",
          },
          {
            caption: "Contract No.",
            dataField: "contrNo",
          },
          {
            caption: "Quotation No.",
            dataField: "quotNo",
          },
          {
            caption: "Task Code No.",
            dataField: "codeNo",
          },
          {
            caption: "Subject",
            dataField: "subject",
          },
          {
            caption: "Start Date",
            dataField: "startDate",
          },
          {
            caption: "End Date",
            dataField: "End Date",
          },
          {
            caption: "Description",
            dataField: "descr",
          },
          {
            caption: "Working Time (Sum)",
            dataField: "time",
            dataType: "number",
            summaryType: "sum",
            area: "data",
            format: {
              type: "fixedPoint",
              precision: 2,
            },
            // visible: false,
            allowInChart: true,
          },
          {
            caption: "Working Time (Avg)",
            summaryType: "avg",
            area: "data",
            dataField: "time",
            format: {
              type: "fixedPoint",
              precision: 2,
            },
          },
        ],
        store: result.data,
      })
    );
  }, []);

  const onExporting = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Individual Report");
    exportPivotGrid({
      component: e.component,
      worksheet,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "Individual Report.xlsx"
        );
      });
    });

    e.cancel = true;
  };

  const onContentReady = (e) => {
    // 1. Find the target container (the header/toolbar element)
    const toolbarContainer = e.element.querySelector(".dx-pivotgrid-toolbar");

    // The Field Chooser button usually has the icon 'dataview'
    // The Export button usually has the icon 'export'
    // We want to add our button before these.

    // 2. Check if the button already exists to prevent duplicates on re-render
    if (
      toolbarContainer &&
      !toolbarContainer.querySelector(".custom-action-button")
    ) {
      // 3. Create a new div element for the button
      const buttonDiv = document.createElement("div");
      buttonDiv.className = "custom-action-button"; // Add a unique class for checking

      // 4. Prepend the button div to the toolbar container
      // Prepend places it *before* the Field Chooser/Export buttons (on the left)
      toolbarContainer.prepend(buttonDiv);

      // 5. Initialize the DevExtreme dxButton on the new div element
      new Button(buttonDiv, {
        text: "Custom Action",
        icon: "bell", // Use a relevant icon name
        onClick: () => {
          // Example action: Collapse all column headers
          e.component.collapseAll("column");
          alert("Columns collapsed!");
        },
        type: "normal",
      });
    }
  };

  return (
    // <div style={{ margin: "16px 16px" }}>
    <div style={{ marginRight: "16px" }}>
      <PivotGrid
        id="pivotGridForIndividualReport"
        dataSource={dataSource}
        allowSorting={true}
        allowSortingBySummary={true}
        allowFiltering={true}
        showBorders={true}
        showColumnTotals={true}
        showRowTotals={true}
        // showRowGrandTotals={true}
        allowExpandAll={true}
        rowHeaderLayout="tree"
        showTotalsPrior="rows"
        // height={"calc(100vh - 260px)"}
        height={"auto"}
        style={{
          maxHeight: `calc(100vh)`,
        }}
        onExporting={onExporting}
        // onContentReady={onContentReady}
      >
        <FieldPanel
          showColumnFields={true}
          showDataFields={true}
          showFilterFields={true}
          showRowFields={true}
          allowFieldDragging={true}
          visible={true}
        />
        <FieldChooser enabled={true} allowSearch={true} />
        <Scrolling mode={"virtual"} />
        <LoadPanel enabled={true} />
        <HeaderFilter
          showRelevantValues={true}
          width={500}
          height={400}
          allowSearch={true}
        >
          {/* <Search enabled={true} mode={"contains"} timeout={500} /> */}
        </HeaderFilter>
        <Export enabled={true} />
        <StateStoring
          enabled={true}
          type={"localStorage"}
          storageKey={"workRecord-IndividualReportGridLeft"}
        />
      </PivotGrid>
    </div>
  );
}
